import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const chatSend = (session_id, message) =>
  api.post("/chat", { session_id, message }).then((r) => r.data);
